webpackJsonp([114276838955818,60335399758886],{

/***/ 94:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(142);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(94);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 274:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(36);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(274);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'TUSK, Inc. | Footnotes to Frontrunners.'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'We draw on decades of corporate, non-profit, and political victories to empower a new generation of innovators with the hard-won context of yesterday and the tools to shape tomorrow.' }),
	      _react2.default.createElement('meta', { property: 'og:title', content: 'New norms. New ideas. New TUSK.' }),
	      _react2.default.createElement('meta', { property: 'og:description', content: 'The rules have changed. So have we. Let\u2019s get started.' }),
	      _react2.default.createElement('meta', { property: 'og:site_name', content: 'TUSK, Inc.' }),
	      _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	      _react2.default.createElement('meta', { property: 'og:url', content: 'https://tuskinc.com/' }),
	      _react2.default.createElement('meta', { property: 'og:image', content: 'https://tusk-site.netlify.com/OG-FB-TUSK.png' }),
	      _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
	      _react2.default.createElement('meta', { name: 'twitter:title', content: 'New norms. New ideas. New TUSK.' }),
	      _react2.default.createElement('meta', { name: 'twitter:url', content: 'https://tuskinc.com/' }),
	      _react2.default.createElement('meta', { name: 'twitter:description', content: 'The rules have changed. So have we. Let\u2019s get started.' }),
	      _react2.default.createElement('meta', { property: 'twitter:image', content: 'https://tusk-site.netlify.com/OG-Twitter-TUSK.png' })
	    ),
	    children()
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-9c3a5cfe5bb72f7b7bd2.js